export enum SlateTypeBaseVariableId {
  NOTES = 'notes',
}
